module.exports = __webpack_public_path__ + "img/fraud-grey24.4924aa4c.svg";